import React from "react";
import { TESTIMONIALS } from "@/lib/content";
import { Quote } from "lucide-react";

const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#F9F6F0] text-[#0B0410] py-24 lg:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-12 justify-center">
          <span className="h-px w-10 bg-[#3D1565]" />
          <span className="text-[11px] tracking-luxury uppercase text-[#3D1565] font-semibold">
            Clientes
          </span>
          <span className="h-px w-10 bg-[#3D1565]" />
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
          {TESTIMONIALS.map((t, idx) => (
            <figure
              key={idx}
              data-testid={`testimonial-${idx}`}
              className="relative"
            >
              <Quote
                size={36}
                className="text-[#3D1565]/30 mb-6"
                strokeWidth={1.2}
              />
              <blockquote className="font-display text-2xl lg:text-3xl font-light leading-[1.3] text-[#0B0410]">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 text-xs tracking-luxury uppercase text-[#0B0410]/60">
                — {t.author}
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
